import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Stack, type Sx, Body1 } from '@dhl-ui/components'
import { AgreedPlaceIcon } from '@dhl-ui/icons'
import type { AgreedPlaceInterventionPreference } from '@dhl/receiver-preference-api'

type Props = { data: AgreedPlaceInterventionPreference | null; hasRingdoorbell?: boolean; sx?: Sx }

export const DisplayAgreedPlaceValue: FC<Props> = ({ data: agreedPlace, hasRingdoorbell, sx }) => {
  const { t } = useTranslation()

  return (
    <Stack gap={1} sx={sx}>
      {hasRingdoorbell && (
        <Body1 component="span" data-test="not-home-agreedplace-description">
          {t('portal.preferences.agreedPlace.afterNotHome.descriptionValue')}
        </Body1>
      )}
      <Box display="flex" flexDirection="row" data-test="agreedplace-description">
        <AgreedPlaceIcon sx={{ mr: 1 }} />
        <Body1 component="span">{agreedPlace?.description}</Body1>
      </Box>
    </Stack>
  )
}
